var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#261F56",
    d: "M16.33 16h.003V10.13c0-2.87-.618-5.082-3.974-5.082-1.613 0-2.696.885-3.138 1.725h-.046V5.317H5.993V16h3.314V10.71c0-1.393.264-2.739 1.99-2.739 1.698 0 1.724 1.59 1.724 2.83V16h3.308ZM.597 5.318h3.317V16H.597V5.318ZM2.254 0C1.194 0 .334.86.334 1.92c0 1.062.86 1.94 1.92 1.94s1.921-.878 1.921-1.94C4.175.86 3.315 0 2.255 0Z"
  })));
};
export default SvgLinkedin;